import React from 'react';
import { Card, Tag, Typography, Space, Alert, Button } from 'antd';
import { UserOutlined, BookOutlined } from '@ant-design/icons';

const { Text } = Typography;

const statusColors = {
  ATIVA: 'green',
  PENDENTE: 'orange',
  CANCELADA: 'red',
};

const AlunoCard = ({ aluno, matriculas = [], turmasMap, onEdit }) => {
  const pendentes = matriculas.filter((matricula) => (matricula.status || '').toUpperCase() === 'PENDENTE');

  const getTurmaNome = (matricula) => {
    if (!matricula) {
      return 'Turma não informada';
    }

    const nomeDireto = matricula.turma_nome || matricula?.turma?.nome_turm || matricula?.turma?.nome;
    if (nomeDireto) {
      return nomeDireto;
    }

    const turmaId = matricula.id_turma ?? matricula.id_turmas;
    if (!turmaId || !turmasMap) {
      return 'Turma não informada';
    }

    const lookup = typeof turmasMap.get === 'function' ? turmasMap.get(turmaId) : turmasMap[turmaId];
    return lookup?.nome_turm || lookup?.nome || 'Turma não informada';
  };

  const renderMatriculas = () => {
    if (matriculas.length === 0) {
      return <Text type="secondary">Nenhuma matrícula ativa ainda.</Text>;
    }

    return matriculas.map((matricula) => {
      const status = (matricula.status || 'ATIVA').toUpperCase();
      return (
        <div key={`${aluno.id}-${matricula.id}-${status}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0' }}>
          <div>
            <Text strong>{getTurmaNome(matricula)}</Text>
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Ano letivo: {matricula.ano_letivo || '—'}
              </Text>
            </div>
          </div>
          <Tag color={statusColors[status] || 'default'}>{status === 'ATIVA' ? 'ATIVA' : status}</Tag>
        </div>
      );
    });
  };

  return (
    <Card
      hoverable
      style={{ borderRadius: 12 }}
      bodyStyle={{ display: 'flex', flexDirection: 'column', gap: 12 }}
    >
      <Space align="start" size="large">
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            backgroundColor: '#f0f5ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#2f54eb',
            fontSize: 22,
          }}
        >
          <UserOutlined />
        </div>
        <Space direction="vertical" size={0} style={{ width: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
            <Text strong style={{ fontSize: 16 }}>
              {aluno.nome_aluno}
            </Text>
            {typeof onEdit === 'function' && (
              <Button size="small" onClick={() => onEdit(aluno)}>
                Editar
              </Button>
            )}
          </div>
          <Text type="secondary" style={{ fontSize: 13 }}>
            <BookOutlined style={{ marginRight: 6 }} />
            Série: {aluno.id_serie || '—'}
          </Text>
        </Space>
      </Space>

      {pendentes.length > 0 && (
        <Alert
          type="warning"
          message={`${pendentes.length} matrícula(s) pendente(s) de aprovação`}
          showIcon
        />
      )}

      <div>{renderMatriculas()}</div>

    </Card>
  );
};

export default AlunoCard;
